<div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
    <div class="breadcrumb-title pe-3">SETTINGS</div>
    <div class="ps-3">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 p-0">
                <li class="breadcrumb-item"><a href="javascript:;"><i class="bx bx-home-alt"></i></a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Profile & Config</li>
            </ol>
        </nav>
    </div>
</div>
<div class="row">
    <div class="col-xl-4 mx-auto">
        <div class="card">
            <div class="card-body">
                <div class="p-3 rounded">
                    <form class="row g-3" [formGroup]="profile_form" (ngSubmit)="submit('profile')">
                        <div class="col-12">
                            <label class="form-label">Phone Number</label>
                            <input formControlName="phone" id="phone" autocomplete="off" class="form-control">
                            <div *ngIf="pf['phone'].touched && pf['phone'].invalid" class="alert alert-danger">
                                <div *ngIf="pf_phone_errors['required']">Phone number is required.</div>
                                <div *ngIf="pf_phone_errors['pattern']">Please, Enter 10 digit Mobile Number.</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <label class="form-label">Email</label>
                            <input formControlName="email" autocomplete="off" class="form-control">
                            <div *ngIf="pf['email'].touched && pf['email'].invalid" class="alert alert-danger">
                                <div *ngIf="pf_email_errors['required']">Email is required.</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <label class="form-label">Subscription End Date</label>
                            <input formControlName="subscriptionEndDate" autocomplete="off" class="form-control" readonly>
                        </div>
                        <div class="col-12">
                            <div class="d-grid">
                                <button type="submit" class="btn btn-primary" [disabled]="!profile_form.valid">Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4 mx-auto" *ngIf="admin == 'true'">
        <div class="card">
            <div class="card-body">
                <div class="p-3 rounded">
                    <form class="row g-3" [formGroup]="config_form" (ngSubmit)="submit('config')">
                        <div class="col-12">
                            <label class="form-label">Feed Token </label>
                            <input formControlName="feed_token" id="feed_token" autocomplete="off" class="form-control">
                            <div *ngIf="cf['feed_token'].touched && cf['feed_token'].invalid" class="alert alert-danger">
                                <div *ngIf="cf_feed_token_errors['required']">Feed Token is required.</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <label class="form-label">Feed ID</label>
                            <input formControlName="feed_id" autocomplete="off" class="form-control">
                            <div *ngIf="cf['feed_id'].touched && cf['feed_id'].invalid" class="alert alert-danger">
                                <div *ngIf="cf_feed_id_errors['required']">Feed ID is required.</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <label class="form-label">Feed Broker</label>
                            <input formControlName="feed_broker" autocomplete="off" class="form-control">
                            <div *ngIf="cf['feed_broker'].touched && cf['feed_broker'].invalid" class="alert alert-danger">
                                <div *ngIf="cf_feed_broker_errors['required']">Feed ID is required.</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="d-grid">
                                <button type="submit" class="btn btn-primary" [disabled]="!config_form.valid">Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4 mx-auto" *ngIf="admin == 'true'">
        <div class="card">
            <div class="card-body">
                <div class="p-3 rounded">
                    <form class="row g-3">
                        <div class="col-12">
                            <label class="form-label">Contracts - {{ contracts_status }} </label>
                        </div>
                        <div class="col-12">
                            <label class="form-label">Feed User - {{ feed_user_status }}</label>
                        </div>
                        <div class="col-12">
                            <div class="d-grid">
                                <button type="submit" class="btn btn-primary" (click)="loadContracts()">Load Contracts</button>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="d-grid">
                                <button type="submit" class="btn btn-primary" (click)="loginFeedUser()">Login</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

